import React, { useEffect, useState } from "react"
import Login from "./Login"
import Home from "./Home"
import logo from '../assets/images/logo.svg'
import { auth } from '../firebase/firebase';
import { onAuthStateChanged } from "firebase/auth";


export default function Admin() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if (currentUser) {
                setUser(currentUser);
                setLoggedIn(true);
                setLoading(false)
            } else {
                setUser(null);
                setLoggedIn(false);
                setLoading(false)
            }
        });

        return () => unsubscribe();
    }, [setLoggedIn]);

    return (
        <>
            {loggedIn ? <Home setLoggedIn={setLoggedIn} /> : loading ? <Loading /> : <Login setLoggedIn={setLoggedIn} />}
        </>
    )
}

function Loading(){
    return(
        <div style={{
            backgroundColor: 'rgba(255, 255, 255, .7)',
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <img src={logo} style={{ width: '250px' }} alt="" />
        </div>
    )
}